/**
 * Medal Konfigurator Live Preview
 * Renders front: band + medal + emblem/logo + text
 * Renders back:  back medal image + centered engraving text (auto font size)
 *
 * Supports two simultaneous render targets per instance:
 *   '' (main, docked to media column, tab-toggle)
 *   'inline-' (side-by-side preview above buy button)
 */

window.MedalPreview = (function () {

  var instances = {};

  function init(id, config) {
    instances[id] = {
      id: id,
      config: config,
      state: {
        medalUrl: config.defaultImage || null,
        bandUrl: null,
        emblemUrl: null,
        emblemScaleFactor: 1.0,
        emblemRotation: 0,
        emblemOffsetX: 0,
        emblemOffsetY: 0,
        plateUrl: null,
        text: '',
        fontFamily: 'Arial, sans-serif',
        backText: '',
        backFontFamily: 'Arial, sans-serif',
        color: null,
        side: 'front',
      }
    };

    _buildPreviewDOM(id, '');
    _buildPreviewDOM(id, 'inline-');
    _render(id);
    _renderBack(id);

    // Listen to variant changes
    document.addEventListener('variant:update', function (e) {
      if (e.detail && e.detail.resource && e.detail.resource.id) {
        var vid = String(e.detail.resource.id);
        var url = config.variantImages[vid];
        if (url) { instances[id].state.medalUrl = url; _render(id); }
      }
    });
    // Initial variant from URL
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m && config.variantImages[m[1]]) {
      instances[id].state.medalUrl = config.variantImages[m[1]];
      _render(id);
    }
  }

  function _bandStyle(cfg) {
    var bp = cfg.bandPos || {};
    var left  = bp.left  !== undefined ? bp.left  : 1.5;
    var top   = bp.top   !== undefined ? bp.top   : -13;
    var scale = bp.scale !== undefined ? bp.scale : 1.45;
    return 'position:absolute;width:100%;height:100%;object-fit:contain;object-position:top center;pointer-events:none;transform-origin:top center;z-index:3;'
      + 'left:' + left + '%;top:' + top + '%;transform:scale(' + scale + ');';
  }

  function _buildPreviewDOM(id, pfx) {
    var container = document.getElementById('mk-preview-canvas-' + pfx + id);
    if (!container) return;

    container.innerHTML = [
      '<div class="mkp-wrap" id="mkp-wrap-' + pfx + id + '">',
        '<img style="' + _bandStyle(instances[id].config) + '" id="mkp-band-' + pfx + id + '" src="" alt="">',
        '<div class="mkp-medal-wrap" id="mkp-medal-wrap-' + pfx + id + '">',
          '<img class="mkp-medal" id="mkp-medal-' + pfx + id + '" src="" alt="">',
          '<img class="mkp-plate" id="mkp-plate-' + pfx + id + '" src="" alt="" style="display:none;position:absolute;z-index:3;object-fit:contain;pointer-events:none;transform:translate(-50%,-50%);">',
          '<div class="mkp-emblem-wrap" id="mkp-emblem-wrap-' + pfx + id + '">',
            '<img class="mkp-emblem" id="mkp-emblem-' + pfx + id + '" src="" alt="">',
          '</div>',
          '<div class="mkp-text" id="mkp-text-' + pfx + id + '"></div>',
        '</div>',
      '</div>',
    ].join('');
  }

  function _renderTarget(id, pfx) {
    var inst = instances[id];
    if (!inst) return;
    var s = inst.state;
    var cfg = inst.config;
    var pos = cfg.position || {};

    // Skip if target elements don't exist yet
    var medal = document.getElementById('mkp-medal-' + pfx + id);
    if (!medal) return;

    var ex = pos.ex !== undefined ? pos.ex : 50;
    var ey = pos.ey !== undefined ? pos.ey : 40;
    var es = pos.es !== undefined ? pos.es : 30;
    var tx = pos.tx !== undefined ? pos.tx : 50;
    var ty = pos.ty !== undefined ? pos.ty : 72;
    var ts = pos.ts !== undefined ? pos.ts : 8;

    // Medal image
    medal.src = s.medalUrl || '';
    medal.style.display = s.medalUrl ? 'block' : 'none';

    // Band image
    var band = document.getElementById('mkp-band-' + pfx + id);
    if (band) {
      band.src = s.bandUrl || '';
      band.style.display = s.bandUrl ? 'block' : 'none';
    }

    // Emblem — clip-wrap is always fixed to metafield circle size
    var emblemWrap = document.getElementById('mkp-emblem-wrap-' + pfx + id);
    var emblem     = document.getElementById('mkp-emblem-' + pfx + id);
    if (emblemWrap && emblem) {
      var scaleFactor = s.emblemScaleFactor || 1.0;
      var rotation    = s.emblemRotation    || 0;
      var visible = !!s.emblemUrl;
      emblemWrap.style.display = visible ? 'block' : 'none';
      emblemWrap.style.left   = (ex - es / 2) + '%';
      emblemWrap.style.top    = (ey - es / 2) + '%';
      emblemWrap.style.width  = es + '%';
      emblemWrap.style.height = es + '%';
      emblem.src = s.emblemUrl || '';
      var offsetX = s.emblemOffsetX || 0;
      var offsetY = s.emblemOffsetY || 0;
      var transforms = [];
      if (offsetX || offsetY) transforms.push('translate(' + offsetX + '%, ' + offsetY + '%)');
      if (scaleFactor !== 1.0) transforms.push('scale(' + scaleFactor + ')');
      if (rotation)            transforms.push('rotate(' + rotation + 'deg)');
      emblem.style.transform = transforms.length ? transforms.join(' ') : '';
    }

    // Gravur plate (optional overlay for glass products)
    var plateEl = document.getElementById('mkp-plate-' + pfx + id);
    if (plateEl) {
      var px = pos.px !== undefined ? pos.px : -999;
      var py = pos.py !== undefined ? pos.py : -999;
      var pw = pos.pw !== undefined ? pos.pw : 48;
      plateEl.src = s.plateUrl || '';
      plateEl.style.display = s.plateUrl ? 'block' : 'none';
      plateEl.style.left  = px + '%';
      plateEl.style.top   = py + '%';
      plateEl.style.width = pw + '%';
    }

    // Front text (position from metafield)
    var textEl = document.getElementById('mkp-text-' + pfx + id);
    if (textEl) {
      textEl.style.display = s.text ? 'block' : 'none';
      textEl.style.left = tx + '%';
      textEl.style.top = ty + '%';
      textEl.style.fontFamily = s.fontFamily;
      var canvasEl = document.getElementById('mk-preview-canvas-' + pfx + id);
      var cw = (canvasEl && canvasEl.offsetWidth) || 300;
      if (s.plateUrl) {
        // Platte vorhanden: Text vertikal + horizontal auf Platte zentrieren
        var pw = pos.pw !== undefined ? pos.pw : 48;
        var plateW = cw * pw / 100;
        var plateH = plateW * 0.28;          // Seitenverhältnis ~3.5:1
        var textAreaW = plateW * 0.82;
        var textAreaH = plateH * 0.78;
        var lines = s.text.split('\n');
        var maxLen = Math.max.apply(null, lines.map(function(l) { return l.length || 1; }));
        var nLines = lines.length;
        var fsByWidth  = (textAreaW * 0.88) / (maxLen * 0.55);
        var fsByHeight = textAreaH / (nLines * 1.3);
        var fs = Math.max(8, Math.min(fsByWidth, fsByHeight, 32));
        textEl.style.fontSize   = Math.round(fs) + 'px';
        textEl.style.width      = (pw * 0.82) + '%';
        textEl.style.maxHeight  = Math.round(textAreaH) + 'px';
        textEl.style.overflow   = 'hidden';
        textEl.style.wordBreak  = 'break-word';
        textEl.style.transform  = 'translate(-50%, -50%)'; // vertikal + horizontal zentriert
      } else {
        // tw = text box width (% of canvas), ts = text box height (% of canvas)
        // Auto-size: fill the box defined by editor
        var tw = pos.tw !== undefined ? pos.tw : 80;
        var lines3 = s.text.split('\n');
        var maxLen3 = Math.max.apply(null, lines3.map(function(l) { return l.length || 1; }));
        var nLines3 = lines3.length;
        var boxW = cw * tw / 100;
        var boxH = cw * ts / 100;
        var fsByW3 = (boxW * 0.92) / (maxLen3 * 0.55);
        var fsByH3 = (boxH * 0.92) / (nLines3 * 1.25);
        var fs3 = Math.max(8, Math.min(fsByW3, fsByH3));
        textEl.style.fontSize   = Math.round(fs3) + 'px';
        textEl.style.width      = tw + '%';
        textEl.style.maxHeight  = Math.round(boxH) + 'px';
        textEl.style.overflow   = 'hidden';
        textEl.style.wordBreak  = 'break-word';
        textEl.style.transform  = 'translateX(-50%)';
      }
      textEl.textContent = '';
      s.text.split('\n').forEach(function (line, i) {
        if (i > 0) textEl.appendChild(document.createElement('br'));
        textEl.appendChild(document.createTextNode(line));
      });
    }
  }

  function _render(id) {
    _renderTarget(id, '');
    _renderTarget(id, 'inline-');
  }

  function _renderBackTarget(id, pfx) {
    var inst = instances[id];
    if (!inst) return;
    var s = inst.state;
    var cfg = inst.config;

    // Skip if target elements don't exist yet
    var backImg = document.getElementById('mkp-back-medal-' + pfx + id);
    if (!backImg) return;

    var backUrls = cfg.backUrls || {};
    var url = (s.color && backUrls[s.color]) ? backUrls[s.color] : (backUrls.gold || backUrls.silber || backUrls.bronze || '');
    backImg.src = url;
    backImg.style.display = url ? 'block' : 'none';

    var inner = document.getElementById('mkp-back-text-inner-' + pfx + id);
    if (!inner) return;

    if (!s.backText) {
      inner.textContent = '';
      return;
    }

    var outer = document.getElementById('mkp-back-' + pfx + id);
    var w = (outer && outer.offsetWidth) ? outer.offsetWidth : 260;
    var discW = w * 0.72;

    var lines = s.backText.split('\n');
    var maxLen = Math.max.apply(null, lines.map(function (l) { return l.length || 1; }));
    var numLines = lines.length;

    var fsByWidth  = (discW * 0.90) / (maxLen * 0.55);
    var fsByHeight = (discW * 0.72) / (numLines * 1.45);

    var fs = Math.max(9, Math.min(fsByWidth, fsByHeight, 40));

    inner.style.fontSize = Math.round(fs) + 'px';
    inner.style.fontFamily = s.backFontFamily;

    inner.textContent = '';
    lines.forEach(function (line, i) {
      if (i > 0) inner.appendChild(document.createElement('br'));
      inner.appendChild(document.createTextNode(line));
    });
  }

  function _renderBack(id) {
    _renderBackTarget(id, '');
    _renderBackTarget(id, 'inline-');
  }

  // ── Public API ──

  function setBand(id, url) {
    if (!instances[id]) return;
    instances[id].state.bandUrl = url;
    _render(id);
  }

  function clearBand(id) {
    if (!instances[id]) return;
    instances[id].state.bandUrl = null;
    _render(id);
  }

  function setEmblem(id, url) {
    if (!instances[id]) return;
    instances[id].state.emblemUrl = url;
    _render(id);
  }

  function clearEmblem(id) {
    if (!instances[id]) return;
    instances[id].state.emblemUrl = null;
    _render(id);
  }

  function setLogo(id, dataUrl) {
    if (!instances[id]) return;
    instances[id].state.emblemUrl = dataUrl;
    _render(id);
  }

  function clearLogo(id) {
    clearEmblem(id);
  }

  function _showBackCol(id, visible) {
    // Highlight back tab when engraving text is present
    var btnB = document.getElementById('mkp-btn-back-' + id);
    if (btnB) {
      btnB.style.fontWeight = visible ? '700' : '600';
      btnB.title = visible ? 'Rückseite — Gravur vorhanden' : '';
    }
    // Auto-switch to back tab when text is first entered
    if (visible) {
      var back = document.getElementById('mkp-side-back-' + id);
      if (back && back.style.display === 'none') {
        if (typeof mkpToggleSide === 'function') mkpToggleSide(id, 'back');
      }
    }
  }

  function setText(id, text, fontFamily) {
    if (!instances[id]) return;
    instances[id].state.text = text || '';
    instances[id].state.backText = text || '';
    if (fontFamily) {
      instances[id].state.fontFamily = fontFamily;
      instances[id].state.backFontFamily = fontFamily;
    }
    _render(id);
    _showBackCol(id, !!text);
    _renderBack(id);
  }

  function setFont(id, fontFamily) {
    if (!instances[id]) return;
    instances[id].state.fontFamily = fontFamily;
    instances[id].state.backFontFamily = fontFamily;
    _render(id);
    _renderBack(id);
  }

  function setPlate(id, url) {
    if (!instances[id]) return;
    instances[id].state.plateUrl = url;
    _render(id);
  }

  function clearPlate(id) {
    if (!instances[id]) return;
    instances[id].state.plateUrl = null;
    _render(id);
  }

  function setColor(id, color) {
    if (!instances[id]) return;
    instances[id].state.color = color;
    _renderBack(id);
  }

  function scaleEmblem(id, delta) {
    if (!instances[id]) return;
    var s = instances[id].state;
    s.emblemScaleFactor = Math.max(0.2, Math.min(3.0, Math.round((s.emblemScaleFactor + delta) * 10) / 10));
    _render(id);
  }

  function rotateEmblem(id, delta) {
    if (!instances[id]) return;
    instances[id].state.emblemRotation = (instances[id].state.emblemRotation + delta + 360) % 360;
    _render(id);
  }

  function moveEmblem(id, dx, dy) {
    if (!instances[id]) return;
    var s = instances[id].state;
    var limit = 40;
    s.emblemOffsetX = Math.max(-limit, Math.min(limit, Math.round(((s.emblemOffsetX || 0) + dx) * 10) / 10));
    s.emblemOffsetY = Math.max(-limit, Math.min(limit, Math.round(((s.emblemOffsetY || 0) + dy) * 10) / 10));
    _render(id);
  }

  function resetEmblemTransform(id) {
    if (!instances[id]) return;
    instances[id].state.emblemScaleFactor = 1.0;
    instances[id].state.emblemRotation = 0;
    instances[id].state.emblemOffsetX = 0;
    instances[id].state.emblemOffsetY = 0;
    _render(id);
  }

  function showSide(id, side) {
    // kept for API compatibility, no longer used
  }

  return {
    init: init,
    setBand: setBand, clearBand: clearBand,
    setPlate: setPlate, clearPlate: clearPlate,
    setEmblem: setEmblem, clearEmblem: clearEmblem,
    setLogo: setLogo, clearLogo: clearLogo,
    setText: setText, setFont: setFont,
    setColor: setColor,
    showSide: showSide,
    scaleEmblem: scaleEmblem,
    rotateEmblem: rotateEmblem,
    moveEmblem: moveEmblem,
    resetEmblemTransform: resetEmblemTransform,
  };

})();

// Process deferred init queue (konfiguratoren that loaded before this script)
if (Array.isArray(window._mkInitQueue)) {
  window._mkInitQueue.forEach(function(fn) { try { fn(); } catch(e) {} });
}
// Future queue.push() calls execute immediately
window._mkInitQueue = { push: function(fn) { try { fn(); } catch(e) {} } };
